import {
  BUDGET_INFLOW_ITEMS,
  BUDGET_OUTFLOW_ITEMS,
  formatMonthYearWithFy,
  formatUtilizationAmount,
  mapBudgetDetails,
} from "./utilizationReportUtils";
import UtilizationAmountHover from "./UtilizationAmountHover";

const PopupRow = ({ label, value }) => {
  const amount = Number(value) || 0;
  if (amount === 0) return null;

  return (
    <div className="utilization-budget-info__popup-row">
      <span className="utilization-budget-info__popup-label">{label}</span>
      <span className="utilization-budget-info__popup-value">
        {formatUtilizationAmount(amount)}
      </span>
    </div>
  );
};

const getBudgetPopupContext = (blockType, meta = {}) => {
  if (blockType === "prevFy") {
    return `Upto previous FY ${meta.previousFyLabel || "-"}`;
  }

  return `For month - ${formatMonthYearWithFy(
    meta.selectedMonthLabel,
    meta.selectedFyLabel
  )}`;
};

const FyBudgetDetailsPopup = ({
  blockType,
  totalBudget,
  details = {},
  meta = {},
}) => {
  const normalized = mapBudgetDetails(details);
  const inflowTotal = BUDGET_INFLOW_ITEMS.reduce(
    (sum, item) => sum + Number(normalized[item.key] || 0),
    0
  );
  const outflowTotal = BUDGET_OUTFLOW_ITEMS.reduce(
    (sum, item) => sum + Number(normalized[item.key] || 0),
    0
  );

  return (
    <div className="utilization-budget-info__popup utilization-budget-info__popup--prev">
      <div className="utilization-budget-info__popup-title">
        Computation of Budget Availed
        <span className="utilization-budget-info__popup-subtitle">
          {getBudgetPopupContext(blockType, meta)}
        </span>
      </div>

      <div className="utilization-budget-info__popup-body">
        <div className="utilization-budget-info__popup-section">
          <div className="utilization-budget-info__popup-section-title">INFLOWS</div>
          {BUDGET_INFLOW_ITEMS.map((item) => (
            <PopupRow key={item.key} label={item.label} value={normalized[item.key]} />
          ))}
          {inflowTotal !== 0 ? (
            <div className="utilization-budget-info__popup-row utilization-budget-info__popup-row--subtotal">
              <span className="utilization-budget-info__popup-label">TOTAL INFLOW</span>
              <span className="utilization-budget-info__popup-value">
                {formatUtilizationAmount(inflowTotal)}
              </span>
            </div>
          ) : null}
        </div>

        <div className="utilization-budget-info__popup-section">
          <div className="utilization-budget-info__popup-section-title">OUTFLOWS</div>
          {BUDGET_OUTFLOW_ITEMS.map((item) => (
            <PopupRow key={item.key} label={item.label} value={normalized[item.key]} />
          ))}
          {outflowTotal !== 0 ? (
            <div className="utilization-budget-info__popup-row utilization-budget-info__popup-row--subtotal">
              <span className="utilization-budget-info__popup-label">TOTAL OUTFLOW</span>
              <span className="utilization-budget-info__popup-value">
                {formatUtilizationAmount(outflowTotal)}
              </span>
            </div>
          ) : null}
        </div>

        <div className="utilization-budget-info__popup-divider" />

        <div className="utilization-budget-info__popup-row utilization-budget-info__popup-row--total">
          <span className="utilization-budget-info__popup-label">Net Budget Availed</span>
          <span className="utilization-budget-info__popup-value">
            {formatUtilizationAmount(totalBudget)}
          </span>
        </div>
      </div>
    </div>
  );
};

const UtilizationBudgetInfoIcon = ({
  blockType,
  totalBudget,
  details,
  meta,
  children,
}) => {
  const displayValue = children ?? formatUtilizationAmount(totalBudget);

  return (
    <UtilizationAmountHover
      ariaLabel={`View ${blockType === "prevFy" ? "previous FY" : "selected FY"} budget details`}
      popup={
        <FyBudgetDetailsPopup
          blockType={blockType}
          totalBudget={totalBudget}
          details={details}
          meta={meta}
        />
      }
    >
      {displayValue}
    </UtilizationAmountHover>
  );
};

export default UtilizationBudgetInfoIcon;
